import React, { useEffect, useRef } from "react";
import classes from "./Home.module.css";
import Header from "../../components/Header/Header";
import Introduction from "../../components/Introduction/Introduction";
import { useLocation, useSearchParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import PrimaryBanner from "../../components/PrimaryBanner/PrimaryBanner";
import Introduction02 from "../../components/Introduction02/Introduction02";
import InstagramFeed from "../../components/InstagramFeed/InstagramFeed";
import Contacts from "../../components/Contacts/Contacts";
import FooterInfo from "../../components/FooterInfo/FooterInfo";
import { INFORMATIONS } from "../../utils/Const";
import useCheckIsMobile from "../../hook/useCheckIsMobile";

const Home = () => {
  const location = useLocation();
  const { state } = location || {};
  const { isFocusServices, focusServices } = state || {};
  const serviceRef = useRef(null);
  const introductionRef = useRef(null);
  const contactsRef = useRef(null);
  const introduction02Ref = useRef(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const isMobile = useCheckIsMobile()

  useEffect(() => {
    if (focusServices) {
      setTimeout(() => {
        const sectionRef =
          focusServices === "introduction" ? introductionRef : introduction02Ref;
        sectionRef?.current?.scrollIntoView({ behavior: "smooth" });
        window.history.replaceState({}, document.title);
      }, 700);
    }
    if (searchParams.get("booking")) {
      // http://localhost:3000/?booking=true
      //TODO: Replace serviceRef with bookingRef
      serviceRef?.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  const renderTopSeparatorMobile = () => {
  if(!isMobile) return null

    return (
      <div className={classes.topSeparator}>
        <a className={classes.bookNowA} href={`tel:${INFORMATIONS.tel}`}>
          {`Hotline: ${INFORMATIONS.phone}`}
        </a>
      </div>
    );
  };

  return (
    <div className={classes.helloworld}>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{INFORMATIONS.name}</title>
        <meta name="service-details" content="Service description" />
        <meta name="description" content="Best Vietnamese restaurant" />
      </Helmet>
      {renderTopSeparatorMobile()}
      <Header
        introductionRef={introductionRef}
        contactsRef={contactsRef}
        serviceRef={introduction02Ref}
      />
      <PrimaryBanner />
      <Introduction introductionRef={introductionRef} />
      <Introduction02 introduction02Ref={introduction02Ref}/>
      {/*<Services serviceRef={serviceRef} />*/}
      <InstagramFeed />
      <Contacts contactsRef={contactsRef} />
      <FooterInfo />
    </div>
  );
};
export default Home;
